import * as z from 'zod';

import { magazineQuerySchema } from './magazine-query-schema';

export const magazineUpdateSchema = magazineQuerySchema
  .pick({
    id: true,
    name: true,
  })
  .extend({
    status: z.string(),
    website: z.string(),
    icon: z.array(z.number()).nullable(),
  });

export type MagazineUpdateSchema = z.infer<typeof magazineUpdateSchema>;

export const magazineCreateSchema = magazineUpdateSchema.pick({ name: true, status: true, website: true });
export type MagazineCreateSchema = z.infer<typeof magazineCreateSchema>;
